var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNoteTaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17787_6755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17787_6755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42312 17.5832C4.00757 17.5832 3.65257 17.436 3.35812 17.1417C3.06382 16.8473 2.91666 16.4923 2.91666 16.0767V4.92296C2.91666 4.50741 3.06382 4.15241 3.35812 3.85796C3.65257 3.56366 4.00757 3.4165 4.42312 3.4165H15.5769C15.9924 3.4165 16.3474 3.56366 16.6419 3.85796C16.9362 4.15241 17.0833 4.50741 17.0833 4.92296V10.1938C16.8782 10.1062 16.6728 10.0319 16.4671 9.97109C16.2614 9.91012 16.0501 9.8615 15.8333 9.82525V4.92296C15.8333 4.8588 15.8066 4.80005 15.7531 4.74671C15.6998 4.69324 15.641 4.6665 15.5769 4.6665H4.42312C4.35896 4.6665 4.30021 4.69324 4.24687 4.74671C4.1934 4.80005 4.16666 4.8588 4.16666 4.92296V16.0767C4.16666 16.1409 4.1934 16.1996 4.24687 16.253C4.30021 16.3064 4.35896 16.3332 4.42312 16.3332H9.30458C9.33555 16.5639 9.38146 16.7821 9.44229 16.9878C9.50326 17.1934 9.5775 17.3919 9.665 17.5832H4.42312ZM4.16666 16.3332V4.6665V9.82525V9.76275V16.3332ZM6.04166 14.3619H9.38937C9.42576 14.1451 9.47972 13.9339 9.55125 13.7282C9.62291 13.5225 9.7009 13.3171 9.78521 13.1121H6.04166V14.3619ZM6.04166 11.1248H11.3254C11.6843 10.8204 12.0673 10.5653 12.4744 10.3596C12.8815 10.1539 13.3174 10.0078 13.7821 9.9213V9.87484H6.04166V11.1248ZM6.04166 7.88755H13.9583V6.63775H6.04166V7.88755Z",
    fill: "var(--path-color, #395966)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19.2983C13.9594 19.2983 13.0743 18.9335 12.3446 18.2038C11.6149 17.474 11.25 16.5889 11.25 15.5483C11.25 14.5078 11.6149 13.6226 12.3446 12.8929C13.0743 12.1632 13.9594 11.7983 15 11.7983C16.0406 11.7983 16.9257 12.1632 17.6554 12.8929C18.3851 13.6226 18.75 14.5078 18.75 15.5483C18.75 16.5889 18.3851 17.474 17.6554 18.2038C16.9257 18.9335 16.0406 19.2983 15 19.2983ZM14.6313 18.0003H15.3684V15.917H17.4518V15.1799H15.3684V13.0966H14.6313V15.1799H12.548V15.917H14.6313V18.0003Z",
    fill: "#FCBE1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteTaker);
export default __webpack_public_path__ + "static/media/addNoteTaker.75a720733cae376c930954bd9c638a8f.svg";
export { ForwardRef as ReactComponent };